import * as React from 'react';
import { toast } from 'react-toastify';
import { ArrowSmallRightIcon } from '@heroicons/react/24/outline';
import { Button, Container, Row, Spacer, Text } from '@nextui-org/react';
import { useRouter } from 'next/router';
import { ROUTES } from '@src/config/constants';
import { AppFullWidthContainer } from '@src/layouts/app/AppFullWidthContainer';

interface StillFollowingHandlesProps {}

/**
 * @name StillFollowingHandles
 * @description tbd...
 */
export function StillFollowingHandles(_props: StillFollowingHandlesProps) {
  // const {} = props

  // Hooks
  const router = useRouter();

  // Handlers
  const followLink = () => {
    router.push(ROUTES.stillFollowingHandles);
    toast.dismiss();
  };

  return (
    <AppFullWidthContainer>
      <Row align="center">
        <Container>
          <Row>
            <Text>
              You are still following Instagram handles for archived campaigns!
            </Text>
          </Row>
          <Spacer y={0.5} />
          <Row>
            <Button
              onPress={followLink}
              flat
              color="warning"
              icon={<ArrowSmallRightIcon width={20} height={20} />}
            >
              Show me
            </Button>
          </Row>
        </Container>
      </Row>
      <Spacer y={1} />
    </AppFullWidthContainer>
  );
}
